export const getStyles = state => {
  const classNames = ["dial1FirstAnimation", "dial1SecondAnimation", "dial1AnimationEnd", "dial2FirstAnimation", "dial2SecondAnimation", "dial2AnimationEnd"];

  return classNames.reduce((styles, className) => {
    styles[className] = {
      animationName: state[className],
      animationTimingFunction: "linear",
      animationDuration: "1s",
      animationDelay: "0.2s"
    };

    return styles;
  }, {});
};
